// extracted by mini-css-extract-plugin
module.exports = {"content":"_916932","title":"_0fad0e","icon":"decb45","metaFields":"af50c7","avatarContainer":"_11bc6f","avatar":"d655bb"};